<template>
  <div id="logistics">
    <div class="header2">
      <div class="header2Wrap">
        <div class="header2L">
          <img src="@/assets/list/logo.png" alt />
        </div>
      </div>
    </div>
    <!-- 主体 -->
    <div class="main">
      <h3>包裹信息</h3>
      <div class="content">
        <div class="contentL">
          <div class="contentL1">
            <p class="p1">
              <img :src="$store.state.imgUrl+dataList.atPhotoUrl" alt />
            </p>
            <p class="p2">
              <span>物流编号：</span>
              <span>{{dataList.mailNo}}</span>
            </p>
            <p class="p2">
              <span>订单编号：</span>
              <span>{{datas.id}}</span>
            </p>
            <!-- <p class="p2">
              <span>运单单号：</span>
              <span>2233156565466699855</span>
            </p>
            <p class="p2">
              <span>客服电话：</span>
              <span>400-628-1365</span>
            </p> -->
            <p class="p2">
              <span>物流公司：</span>
              <span v-if="datas.wlgl">{{datas.wlgl.atKdmc}}</span>
            </p>
          </div>
            <div class="contentL2">
            <p>
              <span class="tit">物流状态:</span>
              <span v-if="dataList.routes.length">{{dataList.routes[0].firstStatusName}}</span>
            </p>
          </div>
          <div class="contentL2">
            <p>
              <span class="tit">发货仓库:</span>
              <span v-if="datas.atCcmc">
                {{datas.atCcmc}}
              </span>
            </p>
          </div>
          <div class="contentL2">
            <p>
              <span class="tit">收货地址:</span>
              <span>
                {{datas.atShdz}}
              </span>
            </p>
          </div>
            
        </div>
        <div class="contentR">
          <div class="block">
            <el-timeline>
              <el-timeline-item v-if="dataList.routes.length" v-for="(item,index) in dataList.routes" :key="index" :timestamp="item.accept_time" placement="top" color="#f64420">
                <el-card>
                  <h4>{{item.remark}}</h4>
                  <p>{{item.accept_address}}</p>
                </el-card>
              </el-timeline-item>
             
            </el-timeline>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vfooter from "@/components/common/Footer";
import topHead from "@/components/common/topHead";
import footerCopy from "@/components/common/footerCopy";
export default {
  name: "logistics",
  data() {
    return {
      userId: "",
      datas:[],
      dataList:[]
    };
  },
  components: {
    topHead: topHead,
    vfooter: vfooter,
    footerCopy: footerCopy
  },
  created() {
     if (sessionStorage.getItem("userInfo")) {
            this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
             this.userId = this.userInfo.id;
        }
     this.getData();
  },
  methods: {
      getData(){
           var params = {};
           params.id = this.$route.query.id;
           params.createBy =this.userId;
            let url = "/ddgl/getAppIndexListDetailV2";
          this.$http.post(url, params).then(res => {
            if (res.data.code == 200) {
              this.datas = res.data.data;
              this.dataList = res.data.data.msgData.routeResps[0];
            }
          });
      }
  }
};
</script>
<style scoped>
.main {
  max-width: 1440px;
  max-width: 80%;
  width: 1024px;
  height: 100%;
  margin: 0px auto;
}
.header2 {
  width: 100%;
  height: 94px;
  background-color: #f64420;
}
.header2Wrap {
  max-width: 1440px;
  max-width: 80%;
  width: 1024px;
  height: 100%;
  margin: 0px auto;
}
.header2L {
  float: left;
  width: 280px;
  height: 80%;
  margin-top: 10px;
}
.header2L img {
  width: 100%;
  height: 100%;
}
.content {
  width: 100%;
}
.content::after {
  content: "";
  height: 0;
  clear: both;
  overflow: hidden;
  display: block;
  visibility: hidden;
}
.contentL {
  float: left;
  height: 603px;
  width: 30%;
  border: 1px solid #dddddd;
  box-sizing: border-box;
  padding: 20px;
  color: #999999;
}
.contentL1 {
  width: 100%;
  border-bottom: 1px dashed #ddd;
  padding: 10px 0;
}
.contentL1 .p1 {
  width: 50%;
}
.contentL1 .p2 {
  line-height: 25px;
}
.contentL1 .p1 img {
  max-width: 100%;
}
.contentL2 {
  width: 100%;
  border-bottom: 1px dashed #ddd;
  padding: 10px 0;
  line-height: 25px;
  font-size: 14px;
  font-weight: normal;
  letter-spacing: 1px;
  color: #999999;
}
.contentL2 .tit {
  font-weight: bold;
  letter-spacing: 1px;
  color: #666666;
}
.contentR {
  color: #999999;
  float: right;
  height: 603px;
  width: 68%;
  border: 1px solid #dddddd;
  background-color: #f9f9f9;
  overflow-y: auto;
}
.block{
  width:85%;
  margin:20px auto;
}
</style>


// WEBPACK FOOTER //
// src/components/ShoppingMall/logistics.vue